<template>
<div class="chapter">
<div class="inner_page">
<p class="htitle"><a id="page_i"></a>JESUS WAS A LIBERAL</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230240582_01_htitle.vue?f8775cf2